/* G  */
export const GET_TARGETS = 'GET_TARGETS';
export const GET_LIST_OF_TEAM = 'GET_LIST_OF_TEAM';
export const GET_ACTORS = 'GET_ACTORS';
